import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const notificationMarkAsSeenMutationAtom = createMutationAtomFactory(
  'notifications.markAsSeen',
  (params: { ids: string[] }) => ({
    notificationMarkAsSeen: {
      __args: {
        ids: params.ids,
      },
    },
  }),
);
